export default {
    getAllCraftsmen: env => {
        return {
            url: `/${env}/craftsmen`,
            method: 'GET'
        };
    },
    getCraftsmanDetails: (env, craftsmanId) => {
        return {
            url: `/${env}/craftsmen/:craftsmanId`,
            method: 'GET',
            route_params: {
                craftsmanId
            }
        };
    },
    updateCraftsmanDetails: (env, craftsmanId, craftsmanForm) => {
        return {
            url: `/${env}/craftsmen/:craftsmanId`,
            method: 'PATCH',
            route_params: {
                craftsmanId
            },
            patch_params: {
                label: craftsmanForm.label,
                firstname: craftsmanForm.firstname,
                lastname: craftsmanForm.lastname,
                email: craftsmanForm.email,
                telPort: craftsmanForm.telPort === '' ? null : craftsmanForm.telPort,
                telFixe: craftsmanForm.telFixe === '' ? null : craftsmanForm.telFixe,
                isActive: craftsmanForm.isActive,
                craftsmanType: craftsmanForm.craftsmanType,
                managements: craftsmanForm.managements
            }
        };
    },
    getCraftsmanTickets: (env, craftsmanId) => {
        return {
            url: `/${env}/craftsmen/:craftsmanId/tickets`,
            method: 'GET',
            route_params: {
                craftsmanId
            }
        };
    },
    addCraftsman: (env, craftsmanForm) => {
        let params = {};
        Object.keys(craftsmanForm).map(field => {
            if (craftsmanForm[field]) params[field] = craftsmanForm[field];
        });
        return {
            url: `/${env}/craftsmen/add`,
            method: 'POST',
            post_params: params
        };
    },
    resetPassword: (env, craftsmanId, craftsmanForm) => {
        return {
            url: `/${env}/craftsmen/:craftsmanId/resetPassword`,
            method: 'PATCH',
            patch_params: {
                email: craftsmanForm.email,
                lastname: craftsmanForm.lastname,
                firstname: craftsmanForm.firstname
            },
            route_params: {
                craftsmanId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Craftsman/api.js